import React, { useEffect, useState } from 'react';

import HTMLFlipBook from "react-pageflip";
import { useLocation } from 'react-router-dom'

function CatalogoPiezas() {
    const location = useLocation();

    const [flag, setFlag] = useState(false);

    useEffect(() => {
        document.title = `Condiciones de servicio`;
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (location.pathname === '/terminos-y-condiciones') {
            setFlag(true);
        } else {
            setFlag(false);
        }
    }, [location]);

    return (
        <div
            style={{
                display: 'flex',
                background: `${flag ? 'linear-gradient(180deg, rgba(13,17,23,1) 30%, #171726 100%)' : 'transparent'}`,
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                marginBottom: `${flag ? '0px' : '120px'}`,
                transition: 'all 0.5s ease-in-out',
                overflow: 'hidden'
            }}>
            <p style={{ textAlign: 'center', fontSize: '2rem', fontWeight: 'bold', color: '#FFF', marginBottom: '48px' }} as='h1'>
                Condiciones de servicio | Aviso de privacidad
            </p>
            <HTMLFlipBook width={794} height={1123} maxShadowOpacity={0.1} minWidth={350} maxWidth={650}
                showCover={false}
                size="stretch"
                style={{ overflow: 'hidden' }}
                drawShadow={true}
                mobileScrollSupport={true}>
                <div style={{ overflow: 'hidden' }}>
                    <picture>
                        <source srcSet={`./images/politicas/politicas1.webp`} type='image/webp' />
                        <source srcSet={`./images/politicas/politicas1.jpg`} type='image/png' />
                        <img src={`./images/politicas/politicas1.webp`} alt='img-ctalog' style={{ width: '100%' }} />
                    </picture>
                </div>
                <div style={{ overflow: 'hidden' }}>
                    <picture>
                        <source srcSet={`./images/politicas/politicas2.webp`} type='image/webp' />
                        <source srcSet={`./images/politicas/politicas2.png`} type='image/png' />
                        <img src={`./images/politicas/politicas2.webp`} alt='img-ctalog' style={{ width: '100%' }} />
                    </picture>
                </div>
                <div style={{ overflow: 'hidden' }}>
                    <picture>
                        <source srcSet={`./images/politicas/politicas3.webp`} type='image/webp' />
                        <source srcSet={`./images/politicas/politicas3.png`} type='image/png' />
                        <img src={`./images/politicas/politicas3.webp`} alt='img-ctalog' style={{ width: '100%' }} />
                    </picture>
                </div>
                <div style={{ overflow: 'hidden' }}>
                    <picture>
                        <source srcSet={`./images/politicas/politicas4.webp`} type='image/webp' />
                        <source srcSet={`./images/politicas/politicas4.png`} type='image/png' />
                        <img src={`./images/politicas/politicas4.webp`} alt='img-ctalog' style={{ width: '100%' }} />
                    </picture>
                </div>
            </HTMLFlipBook>
        </div>
    );
}

export default CatalogoPiezas;